import * as S from "./Header.style";
import { useEffect, useRef, useState } from "react";
import { Buttons } from "../../atoms/Buttons";
import { HeaderPopup } from "../../molecules/HeaderPopup";
import { useLogout } from "../../../common/hooks/useLogout";
import { ReactComponent as IconMenu } from "../../../styles/assets/svg/icon_sidemenu.svg";
import { ReactComponent as IconUser } from "../../../styles/assets/svg/icon_user.svg";
import { ReactComponent as IconAlarm } from "../../../styles/assets/svg/icon_alarm.svg";
import { ChangePasswordModal } from "../../containers/Member/ChangePasswordModal";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/loginUser";
import { ChangeUserInfo } from "../../containers/Member/ChangeUserInfo";
interface HeaderProps {
  asideToggle?: any;
  asideOpen?: boolean;
  innerWidth: number;
}

export const Header = ({ asideOpen, asideToggle, innerWidth }: HeaderProps) => {
  const logout = useLogout();
  const popupRef = useRef<HTMLDivElement>(null);
  const [popupShow, setPopupShow] = useState(false);
  const [modalPasswordShow, setModalPasswordShow] = useState(false);
  const [modalChangeUserInfoShow, setModalChangeUserInfoShow] = useState(false);
  const userInfo = useRecoilValue(userState);

  // 페이지 새로고침 판별
  const [isRefresh, setIsRefresh] = useState<boolean>(false);

  const popupOutsideClick = (e: any) => {
    if (popupRef.current === e.target) {
      setPopupShow(false);
    }
  };

  useEffect(() => {
    if (!isRefresh) {
      setIsRefresh(true);
    }
  }, [isRefresh]);

  return (
    <>
      <S.HeaderSection>
        <S.ShipModelTit>
          {/* 이게 꼭 필요한가? */}
          {/* {asideOpen === true ? (
            "메인 타이틀"
          ) : innerWidth < 1400 ? (
            <S.HeaderSidemenuBtn type="button" onClick={asideToggle}>
              <IconMenu />
            </S.HeaderSidemenuBtn>
          ) : (
            "메인 타이틀"
          )} */}
        </S.ShipModelTit>
        <S.HeaderBtnBox>
          <Buttons
            type="button"
            size="md"
            layout="icon"
            icon={<IconAlarm />}
            onClick={() => {}}
          />
          <Buttons
            type="button"
            size="md"
            layout="icon"
            icon={<IconUser />}
            onClick={() => {
              setPopupShow(!popupShow);
            }}
          >
            <>
              {/* 직책 : 사용자명 바인딩 */}
              <span style={{ margin: "0 8px" }}>
                {userInfo?.dutiesName + " : "}
              </span>
              <span>{userInfo?.userName}</span>
            </>
          </Buttons>
        </S.HeaderBtnBox>
      </S.HeaderSection>
      {popupShow && (
        <HeaderPopup
          logout={logout}
          popupRef={popupRef}
          popupOutsideClick={popupOutsideClick}
          handleModal={() => {
            setPopupShow(false);
            setModalPasswordShow(!modalPasswordShow);
          }}
          changedInfo={() => {
            setPopupShow(false);
            setModalChangeUserInfoShow(!modalChangeUserInfoShow);
          }}
        />
      )}
      {modalChangeUserInfoShow && (
        <ChangeUserInfo
          setModalShow={setModalChangeUserInfoShow}
          formId="change_userInfo"
        />
      )}
      {modalPasswordShow && (
        <ChangePasswordModal
          setModalShow={setModalPasswordShow}
          userId={userInfo?.userId}
          formId="change_password"
        />
      )}
    </>
  );
};
